import { useState } from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Box, Button, Grid, Link } from '@mui/material';
import { HashLink } from 'react-router-hash-link';

import MenuOption from '../MenuOption';

const hotmobLogo = `${process.env.REACT_APP_BASE_URL}/img/static/header/logo.png`;

const DesktopView = () => {
    const location = useLocation();

    const getContactUsBtnColor = () => {
        const homePage = ['/'];
        const mediaServiceRelatedPage = [
            '/media-service',
            '/data-driven-programmatic',
            '/premium-placement',
            '/campaign-management-service',
            '/china-media-solutions',
            '/ai-creation'
        ];
        const dataServiceRelatedPage = ['/data-service', '/external-data', '/insight-report', '/etl-project'];

        let background = 'unset';
        const color = '#FFFFFF';

        if (homePage.includes(location.pathname) || location.pathname.match(/^\/blog(\/.*)?$/)) {
            background = 'linear-gradient(89.51deg, #E15C12 0.42%, #FCB336 101.32%)';
        } else if (mediaServiceRelatedPage.includes(location.pathname)) {
            background = 'linear-gradient(90deg, #54A390 0%, #4987D8 100%)';
        } else if (dataServiceRelatedPage.includes(location.pathname)) {
            background = 'linear-gradient(148.07deg, #AD5BD7 3.97%, #7B6CF9 100%)';
        } else {
            background = 'linear-gradient(89.51deg, #E15C12 0.42%, #FCB336 101.32%)';
        }

        return {
            background,
            color,
            '&:hover': {
                background,
                color
            }
        };
    };

    return (
        <Grid container spacing={0} sx={{ width: '100% !important', marginLeft: '0 !important' }}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <Link component={RouterLink} to="/">
                        <img alt="hotmob-logo" src={hotmobLogo} width="150" height="60" style={{ width: '150px', height: 'auto' }} />
                    </Link>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '28px', height: '100%' }}>
                    <MenuOption
                        name="Media Service"
                        haveDropDown
                        dropdownDetail={[
                            { name: 'Media Service', url: '/media-service' },
                            { name: 'Data-driven Programmatic', url: '/data-driven-programmatic' },
                            { name: 'Premium Placement', url: '/premium-placement' },
                            { name: 'Campaign Management Service', url: '/campaign-management-service' },
                            { name: 'China Media Solutions', url: '/china-media-solutions' },
                            { name: 'AI Creation', url: '/ai-creation' }
                        ]}
                        url="/media-service"
                        btnMinWidth={133}
                        menuItemMinWidth={300}
                    />
                    <MenuOption
                        name="Data Service"
                        haveDropDown
                        dropdownDetail={[
                            { name: 'Data Service', url: '/data-service' },
                            { name: 'External Data', url: '/external-data' },
                            { name: 'Insight Report', url: '/insight-report' },
                            { name: 'ETL Project', url: '/etl-project' }
                        ]}
                        url="/data-service"
                        btnMinWidth={122}
                        menuItemMinWidth={160}
                    />
                    <MenuOption name="AD Gallery" url="https://showcase.hot-mob.com/" isExternal btnMinWidth={105} />
                    <MenuOption name="Blog" url="/blog" btnMinWidth={55} />
                    <HashLink smooth to="/#about-us" style={{ alignSelf: 'center', textDecoration: 'none' }}>
                        <Button
                            sx={{
                                minWidth: '95px',
                                fontSize: '16px',
                                fontWeight: 400,
                                marginTop: 0,
                                lineHeight: '30px',
                                color: '#4D4D4D99',
                                alignSelf: 'center',
                                cursor: 'pointer',
                                '&:hover': {
                                    color: '#4D4D4D',
                                    fontWeight: 600,
                                    backgroundColor: 'transparent'
                                }
                            }}
                        >
                            About Us
                        </Button>
                    </HashLink>
                    <HashLink smooth to="/#contact-us" style={{ alignSelf: 'center', textDecoration: 'none' }}>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{
                                borderRadius: '100px',
                                fontWeight: 600,
                                padding: '10px 14px',
                                ...getContactUsBtnColor()
                            }}
                        >
                            Contact Us
                        </Button>
                    </HashLink>
                </Box>
            </Grid>
        </Grid>
    );
};

export default DesktopView;
